module.exports = __webpack_public_path__ + "static/img/1.f8e43b8.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/5/1/sp/1.png
// module id = 8IJm
// module chunks = 0